const loadError = 'Ошибка загрузки данных, обратитесь к администратору'
const reportError = 'Ошибка формирования документа'
const deleteError = 'При удалении произошла ошибка'

export { loadError, reportError, deleteError }
